module.exports = __webpack_public_path__ + "static/img/渐变背景@3x.2dbda63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/渐变背景@3x.png
// module id = meSJ
// module chunks = 192